import { useMemo } from 'react';
import { useAuthState } from 'state';
import { SearchResults } from 'types';
import ApiService from './ApiService';

export class SearchService extends ApiService {
    async getSearchResults(accountId: string, queryString: string): Promise<SearchResults> {
        const endPoint = accountId ? `/api/accounts/${accountId}/search?query=${queryString}`
            : `/api/accounts/search?query=${queryString}`;
        const { data } = await this.get(endPoint);
        return data;
    }
}

export const useSearchService = () => {
    const auth = useAuthState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => new SearchService(), [auth]);
};